export default "__VITE_ASSET__EeQDZjoU__"